import { render, staticRenderFns } from "./ActionsMarketView.vue?vue&type=template&id=58367806"
import script from "./ActionsMarketView.vue?vue&type=script&lang=js"
export * from "./ActionsMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports